module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library7.09c01cc6.png";